import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Chip,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Paper,
  Collapse,
} from '@mui/material'
import CloudIcon from '@mui/icons-material/Cloud'
import StorageIcon from '@mui/icons-material/Storage'

const DeploymentLocationStep = ({ formData, setFormData, isComplete, stepNumber = 2 }) => {
  return (
    <Collapse in={formData.preExisting !== ''}>
      <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip 
              label={isComplete ? "✓" : String(stepNumber)} 
              color={isComplete ? "success" : "primary"} 
              size="small" 
            />
            Deployment Location
          </Typography>
          <Divider sx={{ my: 2 }} />
          
          <FormControl component="fieldset">
            <FormLabel component="legend">Is the certificate going to AWS? *</FormLabel>
            <RadioGroup
              row
              value={formData.isAWS}
              onChange={(e) => setFormData({ ...formData, isAWS: e.target.value })}
              sx={{ mt: 1 }}
            >
              <Paper
                elevation={formData.isAWS === 'true' ? 3 : 1}
                sx={{
                  p: 2,
                  mr: 2,
                  cursor: 'pointer',
                  border: formData.isAWS === 'true' ? '2px solid' : '1px solid',
                  borderColor: formData.isAWS === 'true' ? 'primary.main' : 'grey.300',
                  minWidth: 150,
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1,
                  '&:hover': { borderColor: 'primary.main' }
                }}
                onClick={() => setFormData({ ...formData, isAWS: 'true' })}
              >
                <CloudIcon sx={{ fontSize: 40, color: formData.isAWS === 'true' ? 'primary.main' : 'grey.500' }} />
                <Typography variant="body1" sx={{ fontWeight: formData.isAWS === 'true' ? 600 : 400 }}>
                  AWS
                </Typography>
                <Radio value="true" checked={formData.isAWS === 'true'} sx={{ display: 'none' }} />
              </Paper>
              <Paper
                elevation={formData.isAWS === 'false' ? 3 : 1}
                sx={{
                  p: 2,
                  cursor: 'pointer',
                  border: formData.isAWS === 'false' ? '2px solid' : '1px solid',
                  borderColor: formData.isAWS === 'false' ? 'primary.main' : 'grey.300',
                  minWidth: 150,
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1,
                  '&:hover': { borderColor: 'primary.main' }
                }}
                onClick={() => setFormData({ ...formData, isAWS: 'false' })}
              >
                <StorageIcon sx={{ fontSize: 40, color: formData.isAWS === 'false' ? 'primary.main' : 'grey.500' }} />
                <Typography variant="body1" sx={{ fontWeight: formData.isAWS === 'false' ? 600 : 400 }}>
                  On-Premises
                </Typography>
                <Radio value="false" checked={formData.isAWS === 'false'} sx={{ display: 'none' }} />
              </Paper>
            </RadioGroup>
          </FormControl>
        </CardContent>
      </Card>
    </Collapse>
  )
}

export default DeploymentLocationStep
